export default __webpack_public_path__ + "static/media/monetization-on.68176dea.svg";